const openIndexedDB = (dbName: string, storeName: string): Promise<IDBDatabase> => {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open(dbName, 1);

		request.onerror = () => {
			reject(new Error("Error opening the IndexedDB"));
		};

		request.onsuccess = (event) => {
			const db = (event.target as IDBRequest).result;
			resolve(db);
		};

		request.onupgradeneeded = (event) => {
			const db = (event.target as IDBRequest).result;
			db.createObjectStore(storeName, { keyPath: "id" });
		};
	});
};

const storeDataInIndexedDB = async (dbName: string, storeName: string, key: string, data: any) => {
	const db = await openIndexedDB(dbName, storeName);
	const transaction = db.transaction([storeName], "readwrite");
	const store = transaction.objectStore(storeName);

	const timestamp = new Date().getTime();
	store.put({ id: key, data, timestamp });
};
const retrieveDataFromIndexedDB = async (dbName: string, storeName: string, key: string): Promise<any | null> => {
	const db = await openIndexedDB(dbName, storeName);
	const transaction = db.transaction([storeName], "readonly");
	const store = transaction.objectStore(storeName);

	const getRequest = store.get(key);
	return new Promise<any | null>((resolve) => {
		getRequest.onsuccess = (event) => {
			const target = event.target as IDBRequest;
			const result = target.result;
			if (result) {
				const { data, timestamp } = result;
				const currentTime = new Date().getTime();

				if (currentTime - timestamp >= 900000) {
					// Data is more than 15 minutes old; you can handle this as needed
					resolve(null); // Return null or handle accordingly
				} else {
					resolve(data);
				}
			} else {
				// Key not found in IndexedDB; you may want to fetch or initialize data here
				resolve(null);
			}
		};

		getRequest.onerror = () => {
			resolve(null);
		};
	});
};

export const IndexedDb = { storeDataInIndexedDB, retrieveDataFromIndexedDB };
export default IndexedDb;
